// Auto-generated by scripts/generate-registry.mjs from packages/modules/pn_logo_bead/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const pn_logo_bead: ModuleSchema = {
  "id": "pn_logo_bead",
  "uniqueId": "B3D_PNLOG",
  "createdAt": "2026-10-14T05:57:06Z",
  "updatedAt": "2026-10-14T05:57:06Z",
  "label": "PN Logo Clicker",
  "description": "PN logo keycap clicker with reusable MX switch, keycap and keychain-loop cores.",
  "category": "fidget",
  "tags": [
    "pn-logo",
    "clicker",
    "mx-switch",
    "keycap",
    "keychain"
  ],
  "sliders": [
    {
      "key": "outerDiameter",
      "label": "Top View Height",
      "min": 36,
      "max": 60,
      "default": 50,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1,
        2,
        3,
        4,
        5
      ]
    },
    {
      "key": "overallDepth",
      "label": "Clicker Base Height",
      "min": 14,
      "max": 30,
      "default": 18,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1,
        2
      ]
    },
    {
      "key": "raisedDepth",
      "label": "Raised Logo Depth",
      "min": 0.4,
      "max": 2,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        2,
        3,
        4,
        5
      ]
    },
    {
      "key": "grooveCount",
      "label": "Outer Wall Vertical Groove Count",
      "min": 0,
      "max": 48,
      "default": 48,
      "step": 1,
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "grooveEndMargin",
      "label": "Groove End Margin",
      "min": 0,
      "max": 12,
      "default": 1.5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "grooveWidth",
      "label": "Square Groove Width",
      "min": 0.4,
      "max": 8,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "grooveDepth",
      "label": "Square Groove Depth",
      "min": 0,
      "max": 10,
      "default": 0.6,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "enableBottomWatermark",
      "label": "Recessed ĐÓM Mark",
      "min": 0,
      "max": 1,
      "default": 0,
      "step": 1,
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "bottomWatermarkDepth",
      "label": "Bottom Mark Recess Depth",
      "min": 0.1,
      "max": 0.8,
      "default": 0.6,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "logo_body",
      "label": "PN Logo Clicker Base",
      "default": "#FFFFFF",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "mx_switch",
      "label": "MX Switch",
      "default": "#64748B",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "keycap",
      "label": "PN Logo Keycap",
      "default": "#FFFFFF",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "logo_blue",
      "label": "PN Logo Blue",
      "default": "#007CC2",
      "targetGroupIds": [
        3
      ]
    },
    {
      "key": "logo_dark_blue",
      "label": "PN Logo Dark Blue",
      "default": "#29166F",
      "targetGroupIds": [
        4
      ]
    },
    {
      "key": "logo_red",
      "label": "PN Logo Red",
      "default": "#DA251C",
      "targetGroupIds": [
        5
      ]
    }
  ],
  "objects": [
    {
      "id": "pn_logo_bead",
      "label": "PN Logo Clicker",
      "name": "PN Logo Clicker",
      "color": "#FFFFFF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "logo_body",
          "label": "PN Logo Clicker Base",
          "name": "PN Logo Clicker Base",
          "groupId": 0,
          "colorKey": "logo_body",
          "defaultColor": "#FFFFFF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "mx_switch",
          "label": "MX Switch",
          "name": "MX Switch",
          "groupId": 1,
          "colorKey": "mx_switch",
          "defaultColor": "#64748B",
          "assembled_z_offset": 0,
          "exploded_z_offset": 8,
          "export_stl": true
        },
        {
          "id": "keycap",
          "label": "PN Logo Keycap",
          "name": "PN Logo Keycap",
          "groupId": 2,
          "colorKey": "keycap",
          "defaultColor": "#FFFFFF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 20,
          "export_stl": true
        },
        {
          "id": "logo_blue",
          "label": "PN Logo Blue",
          "name": "PN Logo Blue",
          "groupId": 3,
          "colorKey": "logo_blue",
          "defaultColor": "#007CC2",
          "assembled_z_offset": 0,
          "exploded_z_offset": 23,
          "export_stl": true
        },
        {
          "id": "logo_dark_blue",
          "label": "PN Logo Dark Blue",
          "name": "PN Logo Dark Blue",
          "groupId": 4,
          "colorKey": "logo_dark_blue",
          "defaultColor": "#29166F",
          "assembled_z_offset": 0,
          "exploded_z_offset": 23,
          "export_stl": true
        },
        {
          "id": "logo_red",
          "label": "PN Logo Red",
          "name": "PN Logo Red",
          "groupId": 5,
          "colorKey": "logo_red",
          "defaultColor": "#DA251C",
          "assembled_z_offset": 0,
          "exploded_z_offset": 23,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Complete PN Logo Clicker"
    },
    {
      "id": "0",
      "label": "Download STL - Clicker Base"
    },
    {
      "id": "1",
      "label": "Download STL - MX Switch"
    },
    {
      "id": "2",
      "label": "Download STL - PN Logo Keycap"
    },
    {
      "id": "3",
      "label": "Download STL - PN Logo Blue"
    },
    {
      "id": "4",
      "label": "Download STL - PN Logo Dark Blue"
    },
    {
      "id": "5",
      "label": "Download STL - PN Logo Red"
    }
  ]
};
